import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { IImgMediaDto } from 'src/app/core/dtos/interfaces/i-img-media-dto';
import { IVideoMediaDto } from 'src/app/core/dtos/interfaces/i-video-media-dto';
import { MediaTypes } from '../../enums/media-types';
import { DialogService } from '../../../shared/services/dialog.service';
import { ImgOrVideo, MediaType } from '../../types/media-type';
import { MediaAdderDialogComponent } from '../media-adder-dialog/media-adder-dialog.component';

import { FormArray, FormControl } from '@angular/forms';
@Component({
  selector: 'app-media-adder-condensed',
  templateUrl: './media-adder-condensed.component.html',
  styleUrls: ['./media-adder-condensed.component.scss'],
})
export class MediaAdderCondensedComponent {
  @Input() sectionImgsFormControl: FormArray;
  @Input() addMediaLabel: string;
  @Input() cardTitle: string;
  @Input() isDisabled: boolean;
  @Output() handleInsertImg = new EventEmitter<IImgMediaDto>();
  @Output() handleRemoveImg = new EventEmitter<IImgMediaDto>();

  ADD_MEDIA_TYPE_HANDLERS = {
    [MediaTypes.IMAGE]: (newImgs: ImgOrVideo[]) => {
      this.sectionImgsFormControl.clear();
      newImgs.forEach((ni) =>
        this.sectionImgsFormControl.push(new FormControl(ni))
      );
    },
  };

  REMOVE_MEDIA_TYPE_HANDLERS = {
    [MediaTypes.IMAGE]: ({
      mediaToRemove,
      mediaIndexToRemove,
    }: {
      mediaToRemove: IImgMediaDto;
      mediaIndexToRemove: number;
    }) => {
      this.sectionImgsFormControl.removeAt(mediaIndexToRemove);
      this.handleRemoveImg.emit(mediaToRemove);
    },
  };

  INSERT_MEDIA_TYPE_HANDLERS = {
    [MediaTypes.IMAGE]: this.handleInsertImg,
  };

  MEDIA_TYPES = MediaTypes;

  constructor(
    private dialogService: DialogService,
    @Inject('Window') private window: Window
  ) {}

  onAddMedia(mediaType: MediaType): void {
    this.dialogService
      .openCustomComponentDialog(
        MediaAdderDialogComponent,
        {
          mediaType,
          prevSelectedMedias: this.sectionImgsFormControl.value,
          canSelectMultiple: true,
        },
        true,
        { width: '95%', height: '95vh', maxWidth: '95vw' }
      )
      .afterClosed()
      .subscribe(
        ({
          actionResult,
          data,
        }: {
          actionResult: boolean;
          data: ImgOrVideo[];
        }) => {
          if (actionResult) {
            this.ADD_MEDIA_TYPE_HANDLERS[mediaType](data);
          }
        }
      );
  }
}
